export default "__VITE_ASSET__DAjtDgNU__"